<div class="top-bar__container">
  @if(!isMobile() && !isTablet()){
  <ng-container *ngTemplateOutlet="logo"></ng-container>
  <ng-container *ngTemplateOutlet="searchBox"></ng-container>
  <div class="d-flex gap-8">
    <ng-container *ngTemplateOutlet="customerViewToggle"></ng-container>
    <kendo-dropdownlist
      [class]="'k-rounded-0'"
      #languages
      [data]="availableLanguages"
      [valueField]="'value'"
      [textField]="'text'"
      [valuePrimitive]="true"
      [value]="userSettings().language"
      (valueChange)="changeLanguage($event)"
    >
    </kendo-dropdownlist>
    <ng-container *ngTemplateOutlet="askQuestion"></ng-container>
    <ng-container *ngTemplateOutlet="helpToggle"></ng-container>
    <rc-user-notifications></rc-user-notifications>
  </div>
<!--  <rc-user-menu></rc-user-menu>-->
  }
  @else {
    <ng-container *ngTemplateOutlet="logo"></ng-container>
    @if(isTablet() && !isMobile()) {
      <ng-container *ngTemplateOutlet="searchBox"></ng-container>
    }
    <div class="d-flex gap-8 align-items-center">
      <ng-container *ngTemplateOutlet="customerViewToggle"></ng-container>
     @if(isMobile() && hasSearch()) {
        @let searchLabel = "SEARCH" | translate | capitalize;
        <button
          kendoButton
          class="k-button-clear notifications-button d-flex align-items-center p-0 top-bar_mobile__search"
          [class.top-bar_mobile__search--open]="isSearchOpen()"
          [title]="searchLabel"
          [attr.aria-label]="searchLabel"
          [attr.aria-expanded]="isSearchOpen()"
          (click)="toggleSearch()"
        >
          <i class="rc-icon-search fs-24" [class]="isSearchOpen() ? 'fc-primary-500' : 'fc-neutral-600'"></i>
        </button>
     }
      <ng-container *ngTemplateOutlet="askQuestion"></ng-container>
      <ng-container *ngTemplateOutlet="helpToggle"></ng-container>
      <rc-user-notifications></rc-user-notifications>
      @if(menu() && isMobile() && !customerView.isActive()) {
        <rc-crowndesk-menu [user]="user()!" [menu]="menu()!" [isMobile]="isMobile() || isTablet()"></rc-crowndesk-menu>
      }
<!--      @if (isMobile() && menu()) {-->
<!--        <div-->
<!--          class="d-flex flex-column h-inherit w-inherit"-->
<!--          kendoPopoverAnchor-->
<!--          [popover]="mobileMenuPopover"-->
<!--          [showOn]="'click'"-->
<!--          [tabIndex]="0"-->
<!--        >-->
<!--        <button-->
<!--          kendoButton-->
<!--          #hamburgerBtn-->
<!--          class="hamburger-button k-button-clear notifications-button h-inherit w-inherit p-0"-->
<!--        >-->
<!--          <i class="rc-icon-hamburger-menu fc-neutral-600 fs-24"></i>-->
<!--        </button>-->

<!--        <kendo-popover #mobileMenuPopover-->
<!--                       [animation]="false"-->
<!--                       [callout]="false"-->
<!--                       class="overflow-y-auto"-->
<!--                       position="bottom">-->
<!--          <ng-template kendoPopoverBodyTemplate>-->
<!--            <div class="rc-popover rc-popover-skin rc-popover&#45;&#45;no-callout mobile-menu-popover d-flex flex-column gap-8">-->
<!--              @for (item of menu(); track item) {-->
<!--                @let itemClass = isMobile() ? "mobile-menu-item" : "";-->
<!--                @let hostClass = isMobile() ? "mobile-menu-item" : "";-->
<!--                @if (item.items) {-->
<!--                  &lt;!&ndash; If you have nested menu items, you can render a simpler version here &ndash;&gt;-->
<!--&lt;!&ndash;                  <button&ndash;&gt;-->
<!--&lt;!&ndash;                    kendoButton&ndash;&gt;-->
<!--&lt;!&ndash;                    class="w-100 text-start bgc-base-white"&ndash;&gt;-->
<!--&lt;!&ndash;                    [routerLink]="[item.url]"&ndash;&gt;-->
<!--&lt;!&ndash;                    [queryParams]="item.params"&ndash;&gt;-->
<!--&lt;!&ndash;                  >&ndash;&gt;-->
<!--&lt;!&ndash;                    <i [class]="item.icon" class="me-8"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                    {{ item.text | translate | capitalize }}&ndash;&gt;-->
<!--&lt;!&ndash;                  </button>&ndash;&gt;-->
<!--                  <rc-menu-dropdown [hostClass]="hostClass" [itemClass]="itemClass" [dropdownMenu]="item" [defaultOpen]="false"></rc-menu-dropdown>-->
<!--                } @else {-->
<!--                  <button-->
<!--                    kendoButton-->
<!--                    class="w-100 text-start bgc-base-white px-0"-->
<!--                    [routerLink]="[item.url]"-->
<!--                    [queryParams]="item.params"-->
<!--                    [routerLinkActive]="['active']"-->
<!--                    [routerLinkActiveOptions]="{-->
<!--                    paths: 'subset',-->
<!--                    fragment: 'ignored',-->
<!--                    matrixParams: 'ignored',-->
<!--                    queryParams: 'ignored'-->
<!--                  }"-->
<!--                  >-->
<!--                    <i [class]="item.icon" class="me-8 fs-24"></i>-->
<!--                    {{ item.text | translate | capitalize }}-->
<!--                  </button>-->
<!--                }-->
<!--              }-->
<!--            </div>-->
<!--          </ng-template>-->
<!--        </kendo-popover>-->
<!--        </div>-->
<!--      }-->
    </div>
  }
</div>
@if (isImpersonating()) {
  <!-- A Royal Crown employee is logged in as a client employee: always visible, with a way back -->
  <div class="top-bar__impersonation" role="status">
    <i class="rc-icon-eye fs-16" aria-hidden="true"></i>
    <span class="top-bar__impersonation-text">
      {{ "IMPERSONATING_AS" | translate: { name: user().fullName || user().name } | capitalize }}
      @if (user().companyName) {
        <span class="fc-neutral-600">· {{ user().companyName }}</span>
      }
    </span>
    <button kendoButton fillMode="link" type="button" class="top-bar__impersonation-stop" (click)="stopImpersonation()">
      {{ "STOP_IMPERSONATION" | translate | capitalize }}
    </button>
  </div>
}
@if (isMobile() && isSearchOpen()) {
  <div class="top-bar__search-panel">
    <ng-container *ngTemplateOutlet="searchBox"></ng-container>
  </div>
}

@if (isHelpOpen()) {
  <!-- The manual of the current screen, opened with the help icon, ? or F1 -->
  <rc-help-panel
    #helpPanel
    [basePath]="helpBasePath()"
    [article]="helpArticle()"
    [topics]="helpTopics"
    (closed)="closeHelp()" />
}

<ng-template #logo>
  <h1 class="top-bar__title fc-primary-500">
    <!-- The logo leads to the dashboard, as in most apps -->
    <a
      class="top-bar__title-link top-bar__title-label d-flex align-items-center gap-8"
      routerLink="/dashboard"
      [title]="'DASHBOARD' | translate | capitalize"
    >
      <div class="d-flex bgc-primary-500 border-radius-36 fs-12 fw-600 px-8 py-4 top-bar__icon"></div>
      <span>
        <span class="top-bar__title-text fw-900 fs-20 fc-primary-500">CROWN</span>
        <span class="top-bar__title-accent fs-20 fc-primary-500">DESK</span>
      </span>
    </a>
  </h1>
</ng-template>

<ng-template #searchBox>
  @if (hasSearch()) {
    @let search = searchTypes();
    <rc-search-box
      class="top-bar__search"
      [hitTypes]="searchHitTypes"
      [types]="search.types"
      [allTypes]="search.allTypes"
      [itemsPerPage]="userSettings().itemsPerPage"
      (hitOpened)="closeSearch()"
      (keydown.escape)="closeSearch()" />
  }
</ng-template>

<ng-template #customerViewToggle>
  @if(customerView.isAvailable()) {
    @let customerViewLabel = (!customerView.isActive() ? "VIEW_AS_CUSTOMER" : "VIEW_AS_CROWNDESK_USER") | translate | capitalize;
    <button
      kendoButton
      kendoTooltip
      position="bottom"
      [offset]="12"
      tooltipClass="tooltip-arrow-top"
      class="k-button-clear notifications-button d-flex align-items-center p-0 fc-neutral-800"
      [title]="customerViewLabel"
      [attr.aria-label]="customerViewLabel"
      [attr.aria-pressed]="customerView.isActive()"
      (click)="customerView.set(!customerView.isActive())"
    >
      <i class="fs-24" [class]="customerView.isActive() ? 'rc-icon-eye fc-primary-500' : 'rc-icon-eye-off'"></i>
    </button>
  }
</ng-template>

<ng-template #helpToggle>
  @let helpLabel = "HELP" | translate | capitalize;
  <button
    kendoButton
    kendoTooltip
    type="button"
    position="bottom"
    [offset]="12"
    tooltipClass="tooltip-arrow-top"
    class="k-button-clear notifications-button d-flex align-items-center p-0 top-bar__help"
    [title]="helpLabel + ' (?)'"
    [attr.aria-label]="helpLabel"
    [attr.aria-expanded]="isHelpOpen()"
    (click)="toggleHelp()"
  >
    <i class="rc-icon-help fs-24" [class]="isHelpOpen() ? 'fc-primary-500' : 'fc-neutral-600'"></i>
  </button>
</ng-template>

<ng-template #askQuestion>
  <!-- Not in the customer view: the screen is then shown to the client's own customer -->
  @if (!customerView.isActive() && canAskQuestion()) {
    @let askQuestionLabel = "ASK_A_QUESTION" | translate | capitalize;
    <button
      kendoButton
      kendoTooltip
      type="button"
      position="bottom"
      [offset]="12"
      tooltipClass="tooltip-arrow-top"
      class="k-button-clear notifications-button d-flex align-items-center p-0 top-bar__ask-question"
      [title]="askQuestionLabel"
      [attr.aria-label]="askQuestionLabel"
      (click)="openAskQuestion()"
    >
      <i class="rc-icon-mail-question fs-24 fc-neutral-600"></i>
    </button>
  }
</ng-template>
